// Espejo de deskte-api/src/utils/alcanceDelAsiento.ts. La explicacion larga
// —por que hizo falta, y por que el filtro va por "quien la creo" y no por
// "de quien es"— esta alli; aqui solo vive el valor, para que la pantalla y el
// servidor no puedan escribirlo distinto.
//
// Hay una prueba que compara los dos archivos y se pone en rojo si se separan
// (tests/unit/soloSusProspectos.test.ts).

/** Valor de `seatScope`: el asiento solo ve los PROSPECTOS que el mismo creo. */
export const SOLO_SUS_PROSPECTOS = 'propios';

/** Los tres alcances que ENSANCHAN mas alla del supervisor, o lo mantienen. */
export const ALCANCES_ANCHOS = ['owners', 'agency'];

/** ¿Este `seatScope` es el de "solo sus prospectos"? */
export function esSoloSusProspectos(seatScope) {
  return seatScope === SOLO_SUS_PROSPECTOS;
}

/**
 * El valor que debe mostrar el desplegable. Sin esto, un asiento guardado como
 * "propios" pintaria "Solo su supervisor" —el `else` de la expresion vieja— y
 * la duena leeria en pantalla justo lo contrario de lo que esta guardado.
 */
export function valorDelDesplegable(seatScope) {
  if (seatScope === 'owners' || seatScope === 'agency') return seatScope;
  if (esSoloSusProspectos(seatScope)) return SOLO_SUS_PROSPECTOS;
  return 'supervisor';
}
